// redux/reducers/categoryModalReducer.js
const initialState = {
    isModalVisible: false,
  };
  
  const makeModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_MAKE_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_MAKE_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default makeModalReducer;
  